/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/building
 */
import { default as DefaultIcon } from '~icons/lucide/building';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const BuildingIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
